import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import styles from './physicalCards.module.scss';
import { actions } from '../../state';
import {
  formatDate,
  formatMoney,
  mapPhysicalCardTransactionType,
  mapPhysicalCardTransactionTypeColor,
} from '../../utils';
import { Table, TableCell, TableRow, TitleSecondary } from '../../components';

const PAGE_SIZE = 10;

const tableHeader = [
  'Laikas',
  'Veiksmas',
  'Lokacija',
  'Įrenginys',
  'Suma',
  'Likutis po',
];

const Usage = ({
  dispatch,
  cardId,
  physicalCards: { usage, usageTotal, loading },
}) => {
  const [page, setPage] = useState(1);
  const pageCount = Math.ceil(usageTotal / PAGE_SIZE) || 1;

  useEffect(() => {
    if (page > pageCount) {
      setPage(1);
    }
  }, [page, pageCount]);

  const fetchUsage = useCallback(
    (id, offset) => {
      dispatch(
        actions.physicalCards.getPhysicalCardUsageAction(id, {
          limit: PAGE_SIZE,
          offset,
        })
      );
    },
    [dispatch]
  );

  useEffect(() => {
    setPage(1);
  }, [cardId]);

  useEffect(() => {
    const offset = (page - 1) * PAGE_SIZE;
    fetchUsage(cardId, offset);
  }, [fetchUsage, cardId, page]);

  const renderTable = () =>
    usage.map(
      ({
        id,
        created_at,
        type,
        location_name,
        device_name,
        amount,
        balance_after,
      }) => (
        <TableRow key={id}>
          <TableCell>{created_at ? formatDate(created_at) : '-'}</TableCell>
          <TableCell>
            <span style={{ color: mapPhysicalCardTransactionTypeColor(type) }}>
              {mapPhysicalCardTransactionType(type)}
            </span>
          </TableCell>
          <TableCell>{location_name || '-'}</TableCell>
          <TableCell>{device_name || '-'}</TableCell>
          <TableCell>{amount != null ? formatMoney(amount) : '-'}</TableCell>
          <TableCell>
            {balance_after != null ? formatMoney(balance_after) : '-'}
          </TableCell>
        </TableRow>
      )
    );

  return (
    <div className={styles.usageSection}>
      <TitleSecondary>Naudojimo istorija</TitleSecondary>
      <Table
        header={tableHeader}
        isEmpty={!usage.length}
        loading={loading}
        page={page}
        pageSize={PAGE_SIZE}
        total={usageTotal}
        serverPagination={true}
        onPageChange={setPage}
      >
        {renderTable()}
      </Table>
    </div>
  );
};

const mapStateToProps = state => ({
  physicalCards: state.physicalCards,
});

Usage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  cardId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  physicalCards: PropTypes.shape({
    usage: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        created_at: PropTypes.number,
        type: PropTypes.number,
        location_name: PropTypes.string,
        device_name: PropTypes.string,
        amount: PropTypes.number,
        balance_after: PropTypes.number,
      })
    ).isRequired,
    usageTotal: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps)(Usage);
